import {Header, Pagination} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {TableSkeleton} from '@/components/Table/TableSkeleton';

import ProcessorFilters from './ProcessorFilters';
import ProcessorTable from './ProcessorTable';
import useProcessorList from './useProcessorList';

const ProcessorList = () => {
  const {
    isLoading,
    list,
    total,
    setPage,
    isPageReset,
    isSearch,
    searchTerm,
    handleSearch,
    statusFilter,
    handleStatusFilter,
    statusCounts,
  } = useProcessorList();

  return (
    <main className="my-5 mx-4 md:mx-10">
      <Header title="Processors" />
      <ProcessorFilters
        searchTerm={searchTerm}
        handleSearch={handleSearch}
        statusFilter={statusFilter}
        handleStatusFilter={handleStatusFilter}
        statusCounts={statusCounts}
      />

      <section className="pt-5 md:pt-5">
        {isLoading ? <TableSkeleton /> : <ProcessorTable items={list} />}
      </section>

      {list.length ? (
        <Pagination
          onPageChange={
            ((params) =>
              setPage(params.page as number)) as PaginationProps['onPageChange']
          }
          total={total}
          isSearch={isSearch}
          isPageReset={isPageReset}
        />
      ) : null}
    </main>
  );
};

export default ProcessorList;
